// Copyright (c) Bentley Systems, Incorporated. All rights reserved.
import * as Sentry from "@sentry/browser"

import readEnv from "~/src/readEnv"
import ignoreErrors from "~/data/sentry-ignore-errors"

const sentryConfig = readEnv("sentry") || {}

const { dsn, release, appName, user, requestId, sessionId } = sentryConfig

Sentry.init({
  dsn,
  release,
  ignoreErrors,
})
Sentry.setUser(user)
Sentry.setTag("request_id", requestId)
Sentry.setTag("session_id", sessionId)
Sentry.setTag("app_name", appName)
